import authCss from '~/styles/auth.css';

export { Layout as default } from './Layout';

export function links() {
  return [
  {
    rel: 'stylesheet',
    href: authCss
  }];

}